import React from 'react';
import { colorConstants } from 'config/colorConstants';

const HeaderSortDescChevron = ({ color = colorConstants.blackTitle }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 7 8 5" fill="none" aria-hidden>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.195262 7.5286C0.455612 7.26825 0.877722 7.26825 1.13807 7.5286L4 10.3905L6.86193 7.5286C7.12228 7.26825 7.54439 7.26825 7.80474 7.5286C8.06509 7.78895 8.06509 8.21106 7.80474 8.4714L4.4714 11.8047C4.21106 12.0651 3.78894 12.0651 3.5286 11.8047L0.195262 8.4714C-0.0650874 8.21106 -0.0650874 7.78895 0.195262 7.5286Z"
            fill={color}
        />
    </svg>
);

export default HeaderSortDescChevron;
